import { __assign, __makeTemplateObject, __rest, __spreadArrays } from "tslib";
import difference from 'lodash/difference';
import omit from 'lodash/omit';
import { arrayOf, number, oneOfType, string } from 'prop-types';
import * as React from 'react';
import { compose, getDisplayName } from 'recompose';
import styled, { withTheme } from 'styled-components';
import { color, display, fontSize, height, maxHeight, maxWidth, minHeight, minWidth, space, width, } from 'styled-system';
import { Tooltips } from './tooltips';
var tooltip = new Tooltips();
var prop = oneOfType([number, string, arrayOf(oneOfType([number, string]))]);
var propTypes = {
    width: prop,
    minWidth: prop,
    maxWidth: prop,
    height: prop,
    minHeight: prop,
    maxHeight: prop,
    display: prop,
    fontSize: prop,
    color: prop,
    bg: prop,
    backgroundColor: prop,
    m: prop,
    mt: prop,
    mr: prop,
    mb: prop,
    ml: prop,
    mx: prop,
    my: prop,
    p: prop,
    pt: prop,
    pr: prop,
    pb: prop,
    pl: prop,
    px: prop,
    py: prop,
};
var styledSystemProps = Object.keys(propTypes);
var filterStyledSystemProps = function (passthroughProps) { return function (Base) {
    return React.forwardRef(function (props, ref) {
        var nextProps = omit(props, difference(styledSystemProps, passthroughProps));
        return React.createElement(Base, __assign({}, nextProps, { ref: ref }));
    });
}; };
export var withStyledSystem = function (child) {
    var Base = styled(child)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\t", "\n\t\t", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n\t\t", "\n\t\t", "\n\t"], ["\n\t\t", "\n\t\t", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n\t\t", "\n\t\t", "\n\t"])), space, width, minWidth, maxWidth, height, minHeight, maxHeight, display, fontSize, color);
    Base.displayName = getDisplayName(child);
    Base.propTypes = propTypes;
    return React.forwardRef(function (props, ref) {
        return React.createElement(Base, __assign({}, props, { ref: ref }));
    });
};
export var withTooltip = function (Base) {
    return React.forwardRef(function (_a, ref) {
        var props = __rest(_a, []);
        if (!props.tooltip) {
            return React.createElement(Base, __assign({}, props, { ref: ref }));
        }
        var tooltipProps = tooltip.bindProps(props);
        delete props.tooltip;
        return props.disabled ? (React.createElement("span", { onClick: tooltipProps.onClick, onMouseEnter: tooltipProps.onMouseEnter, onMouseLeave: tooltipProps.onMouseLeave },
            React.createElement(Base, __assign({}, props, { ref: ref })))) : (React.createElement(Base, __assign({}, tooltipProps, { ref: ref })));
    });
};
export default function asRendition(component, additionalEnhancers, passthroughProps) {
    if (additionalEnhancers === void 0) { additionalEnhancers = []; }
    if (passthroughProps === void 0) { passthroughProps = []; }
    return compose.apply(void 0, __spreadArrays([withTheme], (additionalEnhancers || []), [withTooltip,
        withStyledSystem,
        filterStyledSystemProps(passthroughProps)]))(component);
}
var templateObject_1;
